import { Mask } from './Mask';
import { TrimByHeight } from './TrimByHeight';
import { TrimByLength } from './TrimByLength';
import { FadeTrimMethods } from '@Engage.Core';
import { isset } from '@Engage.Core';
export class TrimMask extends Mask {
    constructor(maskingOptions) {
        super(maskingOptions);
        if (!this.maskElement)
            return; // selector not found
        return this.trimContent(this.maskElement);
    }
    trimContent(element) {
        const method = this.maskingOptions.TrimMethod;
        if (method === FadeTrimMethods.AllowedCharacters) {
            this.trimMask = new TrimByLength(this.maskingOptions);
        }
        else if (method === FadeTrimMethods.ContainerHeight) {
            this.trimMask = new TrimByHeight(this.maskingOptions);
        }
        else if (isset(this.maskingOptions.AllowedCharactersCount) && this.maskingOptions.AllowedCharactersCount > 0) {
            this.trimMask = new TrimByLength(this.maskingOptions);
        }
        else {
            this.trimMask = new TrimByHeight(this.maskingOptions);
        }
        this.trimMask.trim(element);
        if ((this.maskingOptions.AllowedFadedCharactersCount || 0) > 1)
            this.trimMask.fade(element);
        return this.trimMask;
    }
}
